module.exports = __webpack_public_path__ + "assets/img/Nexon-3-Landing-Page.88488124.webp";